import { request } from './request';

export interface MeInfo {
    username: string;
    displayName: string;
    email: string;
    isAdmin: boolean;
    /** 站点角色: master=源站(美服); replica=国服只读镜像 */
    siteRole: 'master' | 'replica' | string;
    /** 平台访问授权状态 (2026-08-25): none/pending/approved/rejected; 管理员恒为 approved */
    accessStatus: 'none' | 'pending' | 'approved' | 'rejected' | string;
}

export function fetchMe(): Promise<MeInfo> {
    return request<MeInfo>('/v1/me');
}
